import { NgModule } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideMarkdown, MARKED_OPTIONS } from 'ngx-markdown';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { CookieConsentComponent } from './common/shared/cookie-consent.component';
import { FeedbackDialogComponent } from './common/shared/feedback-dialog.component';
import { HomePageComponent } from './appmain/home-page/home-page.component';
import { AboutComponent } from './appmain/about/about.component';
import { LoginComponent } from './appmain/login/login.component';
import { AuthCallbackComponent } from './appmain/auth-callback/auth-callback.component';
import { ErrorStateMatcher } from '@angular/material/core';
import { errorInterceptor } from './common/services/error.interceptor';


import {FormControl, FormGroupDirective, NgForm } from '@angular/forms';

export class TouchedErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        return !!(control && control.invalid && (control.dirty || control.touched));
    }
}

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    AboutComponent,
    LoginComponent,
    AuthCallbackComponent,
    FeedbackDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule, FormsModule,
    MatIconModule, MatButtonModule, MatFormFieldModule, MatSelectModule, MatInputModule, MatTooltipModule, MatToolbarModule, MatSidenavModule,
    MatExpansionModule, MatMenuModule, MatSnackBarModule, MatDialogModule, MatProgressBarModule, MatTabsModule,
    CookieConsentComponent,
  ],
  providers: [
      provideHttpClient(withInterceptors([errorInterceptor])),
      provideMarkdown({ markedOptions: { provide: MARKED_OPTIONS, useValue: { breaks: true } } }),
      {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline'}},
      { provide: ErrorStateMatcher, useClass: TouchedErrorStateMatcher }
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule {



}



